import Typed from 'react-typed';


function Home(props) {
  return (
    <div className={(props.index == 0) ? "page home-banner white-bg" : "page home-banner white-bg page--inactive"} id="home" style={props.style}>
      <div className="container-fluid p-0">
        <div className="row no-gutters full-screen">
          <div className="col-lg-3 col-xl-4 blue-bg banner">
            <div className="d-flex align-items-center home-user-avtar v-center-box">
              <img src="static/img/dakshim.png" title="" alt="" />
            </div>
          </div>
          <div className="col-lg-9 col-xl-8">
            <div className="page-scroll">
              <div className="page-content">
                <div className="v-center-box d-flex align-items-center">
                  <div className="home-text">
                    <h6 className="dark-color theme-after">Hello, There</h6>
                    <h1 className="dark-color blue-after">I'm Dakshim Chhabra</h1>
                    <p><span id="type-it"><Typed
                    strings={['WEB DEVELOPER', 'NODE JS DEVELOPER', 'REACT JS DEVELOPER', 'JAVASCRIPT DEVELOPER', 'FULL STACK DEVELOPER']} typeSpeed={40} backSpeed={50} backDelay={2000} loop/></span></p>
                    <div class="btn-bar">
                      <a href="https://github.com/dakshim" class="btn btn-theme" target="blank"><i className="fab fa-github"></i> View on Github</a>
                      <a href="https://www.dakshim.com" class="btn btn-theme-black"><i className="fas fa-globe"></i> Visit Website</a>
                    </div>
                  </div>
                  <ul className="social-icons">
                    <li><a className="facebook" href="https://www.facebook.com/dakshim/" target="blank"><i className="fab fa-facebook-f"></i></a></li>
                    <li><a className="instagram" href="https://www.instagram.com/dakshim/"><i className="fab fa-twitter"></i></a></li>
                    <li><a className="github" href="https://dakshim.github.io"><i className="fab fa-github"></i></a></li>
                    <li><a className="linkedin" href="https://www.linkedin.com/in/dakshim"><i className="fab fa-linkedin-in"></i></a></li>
                  </ul>
                </div>
               </div>
             </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
